import { render, staticRenderFns } from "./checkListPage.vue?vue&type=template&id=0ba88720&scoped=true&"
import script from "./checkListPage.vue?vue&type=script&lang=js&"
export * from "./checkListPage.vue?vue&type=script&lang=js&"
import style0 from "./checkListPage.vue?vue&type=style&index=0&id=0ba88720&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba88720",
  null
  
)

export default component.exports